module.exports = __webpack_public_path__ + "img/icon.d1542d67.png";